import * as React from 'react';

import {
  ComboBox,
  ComboBoxRef,
  cn,
  useComboBoxOptions,
} from '@rematter/ui-web';

import { SelectMaterial } from '~/shared/components/select-fields/SelectMaterial';
import { useTranslations } from '~/shared/i18n/useTranslations';

export interface InventoryItemSelectProps {
  options?: { id: string; label: string }[];
  value?: string | null;
  onChange: (itemId?: string) => void;
  disabled?: boolean;
  errorMessage?: string;
  isInvalid?: boolean;
  className?: string;
  optionClassName?: string;
  placeholder?: string;
  useLocalOptions?: boolean;
  fieldRef?: React.RefObject<ComboBoxRef>;
}

export const InventoryItemSelect: React.FC<InventoryItemSelectProps> = ({
  options = [],
  disabled = false,
  value,
  onChange,
  errorMessage,
  isInvalid,
  className,
  optionClassName = 'flex flex-col-reverse',
  placeholder,
  useLocalOptions = false,
  fieldRef,
}) => {
  const t = useTranslations();

  const { query, onChangeQuery, filteredOptions, currentOption } =
    useComboBoxOptions({
      options,
      value: value ?? '',
      disabled,
      maxResults: 20,
    });

  const handleChange = React.useCallback(
    (values: string[]) => {
      onChange(values.at(0));
    },
    [onChange],
  );

  if (useLocalOptions && options.length > 0) {
    return (
      <ComboBox<string>
        placeholder={placeholder ?? t.fields.placeholder.searchMaterial}
        value={value ? [value] : []}
        isDisabled={disabled}
        isInvalid={isInvalid}
        errorMessage={errorMessage}
        onChange={handleChange}
        query={query}
        onChangeQuery={onChangeQuery}
        options={filteredOptions}
        getSelection={() => [{ label: currentOption?.label ?? '' }]}
        className={cn('@InventoryItemSelect', '@MaterialSelect', className)}
        fieldRef={fieldRef}
      />
    );
  }

  return (
    <SelectMaterial
      placeholder={placeholder}
      value={value ?? undefined}
      isDisabled={disabled}
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      onChange={onChange}
      className={cn('@InventoryItemSelect', '@MaterialSelect', className)}
      optionClassName={optionClassName}
      fieldRef={fieldRef}
    />
  );
};
